var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportCalendarPending = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FEB273"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_report_calendar_pending)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 7.99999V12L14.6663 13.3333M18.6663 12C18.6663 15.6819 15.6816 18.6667 11.9997 18.6667C8.31778 18.6667 5.33301 15.6819 5.33301 12C5.33301 8.3181 8.31778 5.33333 11.9997 5.33333C15.6816 5.33333 18.6663 8.3181 18.6663 12Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_report_calendar_pending"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportCalendarPending);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/report-calendar-pending.ba97bb8656d8086629b52ebe3791f284.svg";